import { Button } from "@/components/ui/button";
import { Input } from "@/components/Input";
import { useAuthByCodeForm } from "@/hooks/auth/useAuthByCodeForm";
import LoginLayout from "./LoginLayout";
import { MessageCircle, ArrowLeft, Lock } from "lucide-react";
import { Link } from "react-router-dom";

const LoginCode = () => {
  const { register, errors, onSubmit, isLoading, phone, requiresPin } =
    useAuthByCodeForm();

  return (
    <LoginLayout>
      <div className="mb-6">
        <Link
          to="/auth/login"
          className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-card-foreground transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Changer de numéro
        </Link>
      </div>

      <h2 className="mb-2 font-semibold text-xl text-card-foreground">
        {requiresPin ? "Code PIN" : "Vérification"}
      </h2>

      <div className="flex items-start gap-3 bg-accent-light rounded-lg p-4 mb-6">
        {requiresPin ? (
          <Lock className="h-5 w-5 text-accent flex-shrink-0 mt-0.5" />
        ) : (
          <MessageCircle className="h-5 w-5 text-accent flex-shrink-0 mt-0.5" />
        )}
        <p className="text-sm text-card-foreground leading-relaxed">
          {requiresPin ? (
            <>
              Saisissez votre <strong>code PIN</strong> pour continuer
            </>
          ) : (
            <>
              Un <strong>code de vérification</strong> a été envoyé par WhatsApp
              au <strong>{phone}</strong>. Saisissez-le ci-dessous pour
              continuer.
            </>
          )}
        </p>
      </div>

      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <Input
            label={requiresPin ? "Code PIN" : "Code de confirmation"}
            type={requiresPin ? "password" : "text"}
            id="code"
            placeholder={
              requiresPin ? "Entrez votre code PIN" : "Entrez le code reçu"
            }
            autoComplete={requiresPin ? "current-password" : "one-time-code"}
            inputMode="numeric"
            pattern="\d*"
            autoFocus
            {...register("authCode")}
            error={errors?.authCode}
          />
        </div>

        <Button
          type="submit"
          className="w-full h-auto py-4"
          isLoading={isLoading}
        >
          Confirmer
        </Button>
      </form>
    </LoginLayout>
  );
};

export default LoginCode;
